import { render, staticRenderFns } from "./upDataIDQr.vue?vue&type=template&id=20e1010a&scoped=true"
import script from "./upDataIDQr.vue?vue&type=script&lang=js"
export * from "./upDataIDQr.vue?vue&type=script&lang=js"
import style0 from "./upDataIDQr.vue?vue&type=style&index=0&id=20e1010a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e1010a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e1010a')) {
      api.createRecord('20e1010a', component.options)
    } else {
      api.reload('20e1010a', component.options)
    }
    module.hot.accept("./upDataIDQr.vue?vue&type=template&id=20e1010a&scoped=true", function () {
      api.rerender('20e1010a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/upDataID/upDataIDQr.vue"
export default component.exports